import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Home from "../screens/Home/Home";
import Login from "../screens/Login/Login";
import Signup from "../screens/Signup/Signup";
import SignUpPasswordBase from "../screens/Password/Password";
import LogoutBase from "../screens/Logout/Logout";
import ForgotPasswordBase from "../screens/ForgotPassword/ForgotPassword";
import ForgotPasswordBaseSuccess from "../screens/ForgotPassword/ForgotPasswordSuccess";
import WinnersTab from "../screens/Winners/WinnersTab";
import Sso from "../screens/Sso/Sso";
import { useSelector } from "react-redux";

const RoutesComponent = () => {
  const disableCanLogin = useSelector((state) => state.global?.disableCanLogin);
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {disableCanLogin ? (
        <Route path="*" element={<Navigate replace to="/" />} />
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Signup />} />
          <Route path="/cadastro/senha" element={<SignUpPasswordBase />} />
          <Route path="/logout" element={<LogoutBase />} />
          <Route path="/redefinir-senha" element={<ForgotPasswordBase />} />
          <Route
            path="/redefinir-senha/sucesso"
            element={<ForgotPasswordBaseSuccess />}
          />
          <Route path="/sso" element={<Sso />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </>
      )}
    </Routes>
  );
};

export default RoutesComponent;
